export default class BrandsInterector {

  constructor(service) {
    this.service = service
  }

  getData() {
    return this.service.getData();
  }
}